import { ROUTE_CHANGE_ABORTED_ERROR_MESSAGE } from 'lib/consts/routeChange'

interface IsAbortedRouteChangeErrorParams {
  message: string
}

/**
 * `useSaveChangesBeforeRouteChange` deliberately throws this exact error inside a
 * Next.js `routeChangeStart` handler to abort a navigation when a form has unsaved
 * changes (the Pages Router cancel-route pattern). The throw escapes to
 * `window.onerror`, so Datadog records it as an unhandled error — but it is
 * intended control flow, not a fault.
 */
export const isAbortedRouteChangeError = ({ message }: IsAbortedRouteChangeErrorParams): boolean =>
  message === ROUTE_CHANGE_ABORTED_ERROR_MESSAGE
